import { useState, type FormEvent } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/daiio7jp14a1h3mr74tg';

export default function SubscribeSection() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const trap = String(formData.get('website_alt') ?? '').trim();
    if (trap) {
      setStatus('success');
      setSuccessMsg('订阅成功，我们会把新的爆料线索优先推送给你。');
      return;
    }

    formData.delete('website_alt');

    setStatus('submitting');
    setFormError('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const lowerMsg = String(serverMsg || '').toLowerCase();
      const isSpam = lowerMsg.includes('spam') || lowerMsg.includes('form data is spam');

      if (!response.ok || isSpam || (parsed?.code && parsed.code !== 'OK')) {
        setStatus('error');
        setFormError(
          isSpam || serverMsg
            ? `提交未通过：${String(serverMsg || '请检查填写内容后重试')}`
            : '提交失败，请稍后再试。',
        );
        return;
      }

      setStatus('success');
      setSuccessMsg('订阅成功，我们会把新的爆料线索优先推送给你。');
      form.reset();
    } catch {
      setStatus('error');
      setFormError('网络异常，提交失败，请稍后再试。');
    }
  };

  return (
    <section id="subscribe" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-2">
          <div className="flex flex-col justify-center p-6 md:p-10 lg:p-12">
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.3em] text-secondary-700">
              <i className="ri-mail-send-line text-[14px]" />
              SUBSCRIBE
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[28px]">
              订阅爆料线索，猛料不再错过
            </h2>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">
              留下你的联系方式，我们会在每个专题有实质性进展时推送一次简报。不灌水、不刷屏，
              只发值得看的<strong className="font-medium text-foreground-900">独家与内幕</strong>。
            </p>
            <ul className="mt-6 space-y-3">
              {['每周至多一封简报', '可随时退订，不留痕迹', '线索来源严格保密'].map((point) => (
                <li key={point} className="flex items-center gap-3">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className="ri-lock-2-line text-[13px]" />
                  </span>
                  <span className="font-body text-[13.5px] text-foreground-700">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="border-t border-background-200 bg-background-100/60 p-6 md:p-10 lg:border-l lg:border-t-0 lg:p-12">
            {status === 'success' ? (
              <div className="flex h-full min-h-[280px] flex-col items-center justify-center text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-checkbox-circle-line text-3xl" />
                </span>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                  已收到你的订阅
                </h3>
                <p className="mt-2 max-w-xs font-body text-[13.5px] leading-relaxed text-foreground-600">
                  {successMsg}
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setStatus('idle');
                    setSuccessMsg('');
                  }}
                  className="mt-6 cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 font-label text-[13px] text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  再订阅一个
                </button>
              </div>
            ) : (
              <form
                id="gossip-lead-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
              >
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="lead-email" className="font-label text-[12.5px] text-foreground-700">
                    邮箱 <span className="text-primary-600">*</span>
                  </label>
                  <input
                    id="lead-email"
                    name="email"
                    type="email"
                    required
                    placeholder="you@example.com"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 font-body text-[13.5px] text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="lead-nickname" className="font-label text-[12.5px] text-foreground-700">
                    称呼
                  </label>
                  <input
                    id="lead-nickname"
                    name="nickname"
                    type="text"
                    placeholder="怎么称呼你"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 font-body text-[13.5px] text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="lead-interest" className="font-label text-[12.5px] text-foreground-700">
                    最想追的题材
                  </label>
                  <select
                    id="lead-interest"
                    name="interest"
                    defaultValue="剧组风波"
                    className="w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 font-body text-[13.5px] text-foreground-950 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  >
                    <option value="剧组风波">剧组风波</option>
                    <option value="资本暗线">资本暗线</option>
                    <option value="合约迷局">合约迷局</option>
                    <option value="舆论反转">舆论反转</option>
                    <option value="私域录音">私域录音</option>
                    <option value="旧照回流">旧照回流</option>
                  </select>
                </div>

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="lead-note" className="font-label text-[12.5px] text-foreground-700">
                    想说的线索（选填）
                  </label>
                  <textarea
                    id="lead-note"
                    name="note"
                    maxLength={500}
                    rows={3}
                    placeholder="可留下你想持续关注的专题名称，不超过 500 字"
                    className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 font-body text-[13.5px] text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  />
                </div>

                <input
                  className="gossip-tip-field"
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                {status === 'error' && formError && (
                  <p className="rounded-md bg-primary-50 px-3 py-2 font-body text-[12.5px] text-primary-700">
                    {formError}
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === 'submitting'}
                  className="mt-1 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {status === 'submitting' ? '提交中…' : '订阅爆料简报'}
                </button>
                <p className="font-body text-[11.5px] leading-relaxed text-foreground-500">
                  提交即表示你同意我们仅将联系方式用于简报推送，不会用于其他用途。
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}